<div id="sidebar-wrapper">

  <div class="sidebar-content">

    @if (themeService.isLightMode()) {
    <img class="logo"
      (click)="onHome()"
      src="assets/images/gallery-logo-notext-outline.png"
      alt="logo-light">
    } @else {
    <img class="logo"
      (click)="onHome()"
      src="assets/images/gallery-logo-gold-no-text.png"
      alt="logo-dark">
    }

    @for (item of sidebarItems; track item; let even = $even) {
    <button class="sidebar-button"
      (click)="item.method()">
      <mat-icon class="item-icon"
        [class.even]="even">
        {{item.icon}} </mat-icon>
      <span class="item-text"
        [class.even]="even">
        {{item.title}}</span>
    </button>
    }

    @if (isAdmin) {
    <div class="quick-links">
      @for (link of quickLinks; track link.route) {
      <button mat-icon-button
        class="quick-link-btn"
        [title]="link.title"
        (click)="onQuickLink(link.route)">
        <mat-icon>{{ link.icon }}</mat-icon>
      </button>
      }
    </div>
    }

  </div>
</div>